<template>
	<component
		:is="layout" :class="layoutClass">
		<slot v-if="layout === 'Loading'"/>
		<router-view v-else :key="routerViewKey"/>
	</component>
</template>
<script>
import Auth from "@/apps/clientPortal/layouts/Auth.vue";
import Guest from "@/apps/clientPortal/layouts/Guest.vue";
import GuestDocument from "@/apps/clientPortal/layouts/GuestDocument.vue";
import Loading from "@/apps/clientPortal/layouts/Loading.vue";
import Portal from "@/apps/clientPortal/layouts/Portal.vue";
import Error from "@/layouts/Error.vue";
import {mapGetters, mapState} from "vuex";

const defaultLayout = "Portal";

export default {
	components: {
		Auth,
		Guest,
		GuestDocument,
		Error,
		Loading,
		Portal,
	},

	data() {
		return {
			routerViewKey: 0,
		};
	},

	computed: {
		...mapState("errorsStore", {
			error: (state) => state.error,
		}),
		...mapGetters("authStore", [
			"isDoingInitialLoad",
		]),
		layout() {
			if (this.error) {
				return "Error";
			}

			if (this.isDoingInitialLoad) {
				return "Loading";
			}

			return this.$route.meta?.layout || defaultLayout;
		},
		layoutClass() {
			return "app--portal--" + this.layout.toLowerCase();
		},
	},

	methods: {
		refresh() {
			this.routerViewKey += 1;
		},
	},
};
</script>
